import React from 'react'

export const AppEmojiIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6517 12.6517C11.1872 14.1161 8.81282 14.1161 7.34835 12.6517M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM8.125 8.125C8.125 8.47018 7.98509 8.75 7.8125 8.75C7.63991 8.75 7.5 8.47018 7.5 8.125C7.5 7.77982 7.63991 7.5 7.8125 7.5C7.98509 7.5 8.125 7.77982 8.125 8.125ZM7.8125 8.125H7.81875V8.1375H7.8125V8.125ZM12.5 8.125C12.5 8.47018 12.3601 8.75 12.1875 8.75C12.0149 8.75 11.875 8.47018 11.875 8.125C11.875 7.77982 12.0149 7.5 12.1875 7.5C12.3601 7.5 12.5 7.77982 12.5 8.125ZM12.1875 8.125H12.1938V8.1375H12.1875V8.125Z"
        stroke="#5E5E5E"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

AppEmojiIcon.defaultProps = {
  className: '',
}
